module.exports = __webpack_public_path__ + "dd3d1af8f070f14406c1792c46d76a1e.jpg";